import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddexpensetypepopupComponent } from '../../generalpopup/addexpensetypepopup/addexpensetypepopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';

@Component({
  selector: 'app-addexpense',
  templateUrl: './addexpense.component.html',
  styleUrls: ['./addexpense.component.css']
})
export class AddexpenseComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "Expense";

  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;


  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  ismanualclose: boolean;
  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterexpensetypeid: any = null;
  filterexpensetypename: any = null;


  //Save Validation
  submitted: boolean;
  successfully: boolean;

  //Edit Get Values
  expenseColl: any = [];
  expenseid: number = 0
  expenseBO: any = {}

  expensetypeColl: any = [];
  empColl: any = [];

  expenseform = new FormGroup({
    expenseid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    expensetypeid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    amount: new FormControl(null, Validators.required),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  isLoadingResult: boolean;
  keyword: any = "empname";

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.expenseid = params.id
      }
    });

    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.expensetypeid !== undefined) {
        this.filterexpensetypeid = params.expensetypeid
      }
      if (params.expensetypename !== undefined) {
        this.filterexpensetypename = params.expensetypename
      }

    })
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.expenseform.reset();
      this.fnInitializeFormGroup();

      if (this.expenseid > 0) {
        this.fngetExpense();
      }
      this.fngetExpenseType();
      this.fngetEmpolyee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.expenseid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.expenseform.setValue({
      expenseid: 0,
      empid: null,
      expensetypeid: null,
      transdt: new Date(),
      descr: '',
      amount: null,
      inactive: false
    })
  }

  fngetExpenseType() {

    var data = {
      'expensetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getExpenseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {

            this.expensetypeColl = res.json().result;
          } else {

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }


  fngetEmpolyee() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetExpense() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'expenseid': this.expenseid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getExpense(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.expenseColl = res.json().result;
            var editdata = this.expenseColl[0];
            this.expenseBO = editdata;
            this.fnEditMode(editdata);
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.expenseform.valid) {
        //Check
        var data = {
          'expenseid': this.expenseid,
          'transdt': this.fnFormatDatetime(this.expenseform.get('transdt').value),
          'empid': this.expenseform.get('empid').value,
          'expensetypeid': this.expenseform.get('expensetypeid').value,
          'descr': this.expenseform.get('descr').value,
          'amount': this.expenseform.get('amount').value,
          'inactive': this.expenseform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        if (this.expenseform.get('expenseid').value > 0) {
          //Update 
          this.fnSetExpense(data);
        }
        else {
          //Insert 
          this.fnInsertExpense(data);
        }


      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertExpense(data) {

    this.appService.fnInsertExpense(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new expense has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
            
            var _result = res.json().result;           
            if (_result.length > 0) {
                this.fnEditFormEdit(_result[0].expenseid);              
            }
            // this.ismanualclose = true
            // this.fnCloseForm();
            // var _result = res.json().result;

            // if (_result.length > 0) {                                
            //   var resdata = _result[0];
            //   if (resdata.length > 0) {
            //     this.fnAttachmentSave(resdata[0].expenseid);  
            //   }                
            // }
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetExpense(data) {

    this.appService.fnSetExpense(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The expense has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.expenseid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.expenseid);        
            // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //AddExpenseType
  private fnAddExpenseType() {

    const modalRef = this.productFindService.open(AddexpensetypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetExpenseType();

      if (receivedEntry > 0) {
        this.expenseform.patchValue({ expensetypeid: receivedEntry })
      }
    });

  }
  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }

  fnEditFormEdit(id) {

    this.expenseid=id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    
     let queryParams= {
        'id':id,
        'status': this.filterstatus,
        'empid': this.filteremployeeid,
        'empname': this.filteremployeename,
        'fromdate': this.fnFormatDatetime(this.filterfromdate),
        'todate': this.fnFormatDatetime(this.filtertodate),
        'expensetypeid': this.filterexpensetypeid,
        'expensetypename': this.filterexpensetypename,
      }
   
  
      this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
        this.ngOnInit();      
      });

  }


  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;
      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'expensetypeid': this.filterexpensetypeid,
            'expensetypename': this.filterexpensetypename,
          }
        }
  
        this.router.navigate(['/Expense'], navigationExtras);

      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));

    this.expenseform.setValue({
      expenseid: deptBO.expenseid,
      empid: deptBO.empid,
      expensetypeid: deptBO.expensetypeid,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      amount: deptBO.amount,
      inactive: deptBO.inactive
    });

    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetExpense();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.expenseBO.approvedstatus !== '') {
      if (this.expenseBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.expenseBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }


     //#Attachment
     fnAttachmentBtnClick() {

      const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
      modalRef.componentInstance.formname = this.formname;
      modalRef.componentInstance.trxid = this.expenseid;
      modalRef.componentInstance.formmode = "EDIT";
      modalRef.componentInstance.fnGetAttachment();
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
        if (receivedEntry === 'DONE') {
          this.fngetExpense();
        }
      }); 
  
      // this.attachmentbar.formtype = this.formname;
      // this.attachmentbar.trxid = this.payadvid;
  
      // if (this.payadvid > 0) {
      //   this.attachmentbar.formmode = "EDIT";
      // }
      // else {
      //   this.attachmentbar.formmode = "ADD";
      // }
  
      // this.attachmentbar.fnGetAttachment();
  
      // this.isshowattachment = !this.isshowattachment
  
    }
  
  
    fnAttachmentSave(tid) {
  
      // if (this.attachmentcount > 0) {
  
      //   this.attachmentbar.formtype = this.formname;
      //   this.attachmentbar.trxid = tid;
      //   this.attachmentbar.formmode = "ADD";
  
      //   this.attachmentbar.fnSaveAttachmentByAddMode();
      // }
      // else {
      //   this.fnCloseForm();
      // }
  
    }
  
    fnSetAttachmentCount(data) {
  
      this.attachmentcount = data;
    }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.expenseid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetExpense();
      }


    });
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}
